import React from 'react';
import { useTranslation } from "react-i18next";
import { MyPanel, MyHead1, MyHead3 } from '../../component/ui/UI';

const aboutData =
[
	{
		title: "Magic: The Gathering",
		url: "https://magic.wizards.com/",
		description: "Right_MTG_Description"
	},
	{
		title: "MTGJSON",
		url: "https://mtgjson.com/",
		description: "Right_MTGJSON_Description"
	},
	{
		title: "Scryfall",
		url: "https://scryfall.com",
		description: "Right_Scryfall_Description"
	},
	{
		title: "Bootstrap",
		url: "https://getbootstrap.com/",
		description: "Right_Bootstrap_Description"
	},
	{
		title: "pragmatic-drag-and-drop",
		url: "https://github.com/atlassian/pragmatic-drag-and-drop",
		description: "Right_Pragmatic_Description"
	}
];

export const AboutPage = () =>
{
	const { t } = useTranslation();

	return (
		<div className="d-flex flex-column p-1 gap-1">
			<MyPanel>
				<MyHead1>
					{t("Option_About")}
				</MyHead1>
				<div style={{ whiteSpace: "pre-wrap"}}>{t("About_Message")}</div>
			</MyPanel>
			<MyPanel>
				<MyHead1>
					{t("About_References")}
				</MyHead1>
				<ul className="list-unstyled">
					{aboutData.map(ref => (
						<li key={ref.url} className="mb-3">
							<MyHead3>{ref.title}</MyHead3>
							<div>
								<a href={ref.url} target="_blank" rel="noreferrer">
									{ref.url}
								</a>
							</div>
							<div className="text-muted mt-1">
								{t(ref.description)}
							</div>
						</li>
					))}
				</ul>
			</MyPanel>
		</div>
	);
};
